<table *ngIf='showTable ; else errorTextField' mat-table [dataSource]="tableData" class="details-screen-table scrollable-table">
  <ng-container matColumnDef="cardNumber">
    <th mat-header-cell *matHeaderCellDef> Pasnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.cardNumber ? data.cardNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="sequenceNumber">
    <th mat-header-cell *matHeaderCellDef> Volgnummer </th>
    <td mat-cell *matCellDef="let data"> {{data.sequenceNumber ? data.sequenceNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef> Status </th>
    <td mat-cell *matCellDef="let data"> {{data.status ? data.status : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="validUntil">
    <th mat-header-cell *matHeaderCellDef> Geldig t/m </th>
    <td mat-cell *matCellDef="let data"> {{data.validUntil ? data.validUntil : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="creationDate">
    <th mat-header-cell *matHeaderCellDef> Datum aanvraag </th>
    <td mat-cell *matCellDef="let data"> {{data.creationDate ? data.creationDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="notificationPassFactoryDate">
    <th mat-header-cell *matHeaderCellDef> Datum uitgifte </th>
    <td mat-cell *matCellDef="let data"> {{data.notificationPassFactoryDate ? data.notificationPassFactoryDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="expirationDate">
    <th mat-header-cell *matHeaderCellDef> Datum vervallen </th>
    <td mat-cell *matCellDef="let data"> {{data.expirationDate ? data.expirationDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="replacementDate">
    <th mat-header-cell *matHeaderCellDef> Datum vervangen </th>
    <td mat-cell *matCellDef="let data"> {{data.replacementDate ? data.replacementDate : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="replacementCardSequenceNumber">
    <th mat-header-cell *matHeaderCellDef> Vervangt volgnr. </th>
    <td mat-cell *matCellDef="let data"> {{data.replacementCardSequenceNumber ? data.replacementCardSequenceNumber : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="startDate">
    <th mat-header-cell *matHeaderCellDef> Geblokkeerd per </th>
    <td mat-cell *matCellDef="let data"> {{formatBlocksDate(data)}}</td>
  </ng-container>


  <ng-container matColumnDef="reason">
    <th mat-header-cell *matHeaderCellDef> Reden blokkering </th>
    <td mat-cell *matCellDef="let data"> {{data.blocks && data.blocks.length>0 ? data.blocks[0].reason : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="removable">
    <th mat-header-cell *matHeaderCellDef> Handm. deblokk. mogelijk? </th>
    <td mat-cell *matCellDef="let data"> {{isRemovable(data)}} </td>
  </ng-container>

  <ng-container matColumnDef="requestReason">
    <th mat-header-cell *matHeaderCellDef> Reden bestelling </th>
    <td mat-cell *matCellDef="let data"> {{data.requestReason ? data.requestReason : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="secureElementType">
    <th mat-header-cell *matHeaderCellDef> SE Type </th>
    <td mat-cell *matCellDef="let data"> {{data.secureElementType ? data.secureElementType : emptyValuePlaceholder}} </td>
  </ng-container>

  <ng-container matColumnDef="secureElementId">
    <th mat-header-cell *matHeaderCellDef> SE-ID </th>
    <td mat-cell *matCellDef="let data"> {{data.secureElementId ? data.secureElementId : emptyValuePlaceholder}} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
</table>
<ng-template #errorTextField>
  <div class="error-text">
    {{errorText}}
  </div>
</ng-template>
